import React, { useState, useEffect } from "react";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function formatDate(dateStr) {
  const date = new Date(dateStr);

  const month = date
    .toLocaleString("default", { month: "short" })
    .toUpperCase();

  const day = date.getDate();
  const year = date.getFullYear();

  return { month, day, year };
}


function TopManagementSection({ datacontent, initialPagination, id }) {
  const [newsList, setNewsList] = useState(datacontent || []);
  const [selectedNews, setSelectedNews] = useState(datacontent?.[0] || null);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(
    initialPagination || {
      current_page: 1,
      last_page: 1,
    },
  );
  const [loading, setLoading] = useState(false);
  /* Seperated from the routein */
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleTopManagement = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };
  /* Seperated from the routein */
  const headerTitle =
    datacontent[0]?.title.length > 0 ? datacontent[0]?.title : "Blank Page";
  useEffect(() => {
    setNewsList(datacontent || []);

    setSelectedNews(datacontent?.[0] || null);
  }, [datacontent]);

  useEffect(() => {
    //if (page === 1) return;

    fetchNews();
  }, [page]);

  const fetchNews = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${BASE_URL}posdata?pageName[eq]=${id}&columes[eq]=title_show_echo_01&ministry[eq]=1&status02[eq]=publish&status[eq]=Public&visibility[eq]=Public&display01[eq]=2&page=${page}&per_page=10`,
      );

      const allData = response?.data?.allData || [];

      setNewsList(allData);

      // auto select first news
      setSelectedNews(allData[0] || null);

      setPagination(
        response?.data?.pagination || {
          current_page: 1,
          last_page: 1,
        },
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const { month, day, year } = selectedNews?.daterqw
    ? formatDate(selectedNews.daterqw)
    : { month: "", day: "", year: "" };

  if (!selectedNews) return null;

  

  return (
    <section id="TopManagement" className="tm section light-background">
      {/* Section Title */}
      {/* <div className="container section-title" data-aos="fade-up">
        <h2>At a Glance</h2>
        <p>
          <span>Highlights That</span>{" "}
          <span className="description-title">Matter Most</span>
        </p>
      </div> */}

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10" data-aos="fade-up" data-aos-delay={100}>
            <div className="tm-container">
              {newsList.map((item, index) => {
                const date = new Date(item.daterqw);
                const month = date
                  .toLocaleString("default", { month: "short" })
                  .toUpperCase();
                const day = date.getDate();
                const year = date.getFullYear();

                return (
                  <div
                    className={`tm-item ${activeIndex === index ? "tm-active" : ""}`}
                    key={index}
                    onClick={() => toggleTopManagement(index)}
                    style={{ cursor: "pointer" }}
                  >
                    <h3 className="text-capitalize">{item.title}</h3>

                    <div
                      className="tm-content"
                      style={{
                        maxHeight: activeIndex === index ? "none" : "0",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease, padding 0.3s ease",
                        paddingTop: activeIndex === index ? "15px" : "0",
                        paddingBottom: activeIndex === index ? "15px" : "0",
                      }}
                    >
                      <div className="tm-body clearfix">
                        {item.passport &&
                          item.passport !== "undefined" &&
                          item.passport !== "null" &&
                          item.passport.trim() !== "" && (
                            <>
                              <img
                                loading="lazy"
                                decoding="async"
                                src={`${BACKEND_URL}upload/${item.passport}`}
                                alt={item.title || "Image"}
                                style={{
                                  float: "left",
                                  width: `${Number(item.width01) + Number(10)}%`,
                                  maxWidth: "100%",
                                  height: "auto",
                                  objectFit: "cover",
                                  marginRight: "20px",
                                  marginBottom: "15px",
                                  borderRadius: "8px",
                                }}
                                className="img-fluid rounded"
                              />

                              {/* <div className="vertical-date-badge mb-2 mt-5 ms-3">
                              <div className="date-part">{month}</div>
                              <div className="date-divider">—</div>
                              <div className="date-part vertical-formatDate">
                                {day}
                              </div>
                              <div className="date-divider">—</div>
                              <div className="date-part">{year}</div>
                            </div> */}
                            </>
                          )}

                        <div
                          className="card-text text-secondary"
                          style={{
                            textAlign: "justify",
                            lineHeight: "1.9",
                          }}
                        >
                          <HTMLDisplay html={item.story01} type="title" />
                          <HTMLDisplay html={item.story01} type="body" />
                        </div>

                        {/* <Link to={`/read/${item.id}`} className="read-more-link btn btn-iceberg mt-3 text-start">
                        Read More →
                      </Link> */}
                      </div>
                    </div>
                    <i
                      className={`tm-toggle bi ${
                        activeIndex === index
                          ? "bi-chevron-down"
                          : "bi-chevron-right"
                      }`}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <>
            {/* Pagination Controls */}
            <div className="d-flex justify-content-end align-items-center mt-3">
              <button
                className="btn btn-dark me-2"
                onClick={() => setPage(1)}
                disabled={pagination?.current_page === 1}
              >
                «
              </button>

              <button
                className="btn btn-dark me-2"
                onClick={() => setPage(pagination?.current_page - 1)}
                disabled={pagination?.current_page === 1}
              >
                ‹
              </button>

              <span className="me-2">
                Page {pagination?.current_page} of {pagination?.last_page}
              </span>

              <button
                className="btn btn-dark me-2"
                onClick={() => setPage(pagination?.current_page + 1)}
                disabled={pagination?.current_page === pagination?.last_page}
              >
                ›
              </button>

              <button
                className="btn btn-dark"
                onClick={() => setPage(pagination?.last_page)}
                disabled={pagination?.current_page === pagination?.last_page}
              >
                »
              </button>
            </div>
          </>
        </div>
      </div>
    </section>
  );
}

export default React.memo(TopManagementSection);
